export default __webpack_public_path__ + "static/media/sideimage.fbb4d107.jpg";